import { useTranslation } from 'react-i18next';
import { Card, Colors, Text, Typography } from 'goalsetter-webapp-components';
import {
  Container,
  DownloadContainer,
  HeaderCard,
  ImageContainer,
  cardStyle,
  descriptionStyle,
  titleStyle,
} from './styles';
import { Image } from '@mantine/core';
import Images from '../../../../assets/img/Images';
import { Link } from 'react-router-dom';
import LogoHeader from 'app/components/LogoHeader';

export const ResetPasswordSuccess = () => {
  const { t } = useTranslation();
  const appleStore =
    'https://itunes.apple.com/us/app/goalsetter-co/id1440624866';
  const playStore =
    'https://play.google.com/store/apps/details?id=com.goalsetter';

  return (
    <Container>
      <LogoHeader />
      <Card style={cardStyle}>
        <HeaderCard>
          <ImageContainer>
            <Image src={Images.PASSWORD_USER_SUCCESS} />
          </ImageContainer>
          <Text
            type={Typography.GSH5}
            color={Colors.BLACK}
            style={titleStyle}
          >
            {t('resetPasswordSuccess.title')}
          </Text>
          <Text
            type={Typography.GSBODY2}
            color={Colors.BLACK}
            style={descriptionStyle}
          >
            {t('resetPasswordSuccess.description')}
          </Text>
          <DownloadContainer>
            <Link
              to={appleStore}
              data-testid="linkDownloadApple"
            >
              <Image src={Images.DOWNLOAD_APPLE} />
            </Link>
            <Link
              to={playStore}
              data-testid="linkDownloadGoogle"
            >
              <Image src={Images.DOWNLOAD_GOOGLE} />
            </Link>
          </DownloadContainer>
        </HeaderCard>
      </Card>
    </Container>
  );
};
